import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { OracleResponsysLinkedService } from 'app/model/linkedservice/oracle-responsys.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleResponsysLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                clientId: '*',
                clientSecret: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class OracleResponsysLinkedServiceAdapter extends LinkedServiceAdapter<OracleResponsysLinkedService> {
    protected modelConstructor(): new () => OracleResponsysLinkedService {
        return OracleResponsysLinkedService;
    }

    protected model(): IModel {
        return OracleResponsysLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: OracleResponsysLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.ResponsysLinkedService;
        properties.type = Metamodel.modelFor(OracleResponsysLinkedService).name;

        properties.typeProperties = {
            endpoint: linkedService.endpoint,
            clientId: linkedService.clientId,
            clientSecret: passwordOrAKVtoSecretBase(linkedService.clientSecret, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: OracleResponsysLinkedService): Promise<OracleResponsysLinkedService> {
        const properties = linkedServiceResource.properties as Model.ResponsysLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.ResponsysLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.endpoint = typeProperties.endpoint;
        linkedService.clientId = typeProperties.clientId;
        linkedService.clientSecret = secretBaseToPasswordOrAKV(typeProperties.clientSecret, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
